// 生产环境使用相对路径，开发环境使用 localhost
const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const defaultApiUrl = isLocalhost ? "http://localhost:9080" : "";

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || defaultApiUrl,
  appName: "交易量管理系统",
  version: "1.0.0",

  // 分页配置
  pagination: {
    defaultPageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
  },

  // 图表配置
  chart: {
    defaultColors: [
      "#007bff",
      "#28a745",
      "#ffc107",
      "#dc3545",
      "#17a2b8",
      "#6f42c1",
      "#e83e8c",
      "#fd7e14",
    ],
  },

  // 时间格式配置
  dateFormat: {
    display: "YYYY-MM-DD",
    displayWithTime: "YYYY-MM-DD HH:mm:ss",
    api: "YYYY-MM-DD",
  },

  // 数据刷新间隔（毫秒）
  refreshInterval: 30000,
};

// 单独导出API基础URL，以便于api.js文件导入
export const API_BASE_URL = config.apiUrl;

export default config;
